module.exports = __webpack_public_path__ + "static/img/wechatpay.4e7f268f.png";